import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { ExpectationUnit } from './expectation-unit';
export var Expectation = /*#__PURE__*/function () {
  function Expectation() {
    _classCallCheck(this, Expectation);
  }

  _createClass(Expectation, null, [{
    key: "isValidPercentage",
    value: function isValidPercentage(value) {
      return Number.isFinite(value) && value >= this.minPercentage && value <= this.maxPercentage;
    }
  }, {
    key: "isValidScore",
    value: function isValidScore(value, totalScore) {
      var max = totalScore > 0 ? totalScore : 10;
      return Number.isFinite(value) && value >= 0 && value <= max;
    }
  }, {
    key: "isValid",
    value: function isValid(value) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ExpectationUnit.Percentage;
      var totalScore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

      if (unit === ExpectationUnit.Score) {
        return this.isValidScore(value, totalScore);
      }

      return this.isValidPercentage(value);
    }
  }, {
    key: "normalizeToPercentage",
    value: function normalizeToPercentage(value) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ExpectationUnit.Percentage;
      var totalScore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      if (!Number.isFinite(value)) return 50;

      if (unit === ExpectationUnit.Score) {
        var scale = totalScore > 0 ? totalScore : 10;
        return Math.max(0, Math.min(100, Math.round(value / scale * 100)));
      }

      return Math.max(0, Math.min(100, Math.round(value)));
    }
  }, {
    key: "clamp",
    value: function clamp(value) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ExpectationUnit.Percentage;
      var totalScore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      var max = unit === ExpectationUnit.Score ? totalScore > 0 ? totalScore : 10 : 100;
      return Math.max(0, Math.min(max, value));
    }
  }, {
    key: "formatDisplayText",
    value: function formatDisplayText(expectation) {
      var expectationUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'percentage';
      var totalScore = arguments.length > 2 ? arguments[2] : undefined;
      var unitSuffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'điểm';

      if (expectation === undefined || expectation === null) {
        return '-';
      }

      if (expectationUnit === 'score') {
        if (totalScore && totalScore > 0) {
          return "".concat(expectation, "/").concat(totalScore, " ").concat(unitSuffix).trim();
        }

        return "".concat(expectation, " ").concat(unitSuffix).trim();
      }

      if (totalScore && totalScore > 0) {
        var calculatedScore = Math.round(totalScore * expectation / 100 * 10) / 10;
        return "".concat(calculatedScore, "/").concat(totalScore, " ").concat(unitSuffix, " (").concat(expectation, "%)").trim();
      }

      return "".concat(expectation, "%");
    }
  }]);

  return Expectation;
}();

_defineProperty(Expectation, "minPercentage", 0);

_defineProperty(Expectation, "maxPercentage", 100);